import { Link } from 'react-router-dom'
import { pillars } from '../data/pillars'

export default function Pillars() {
  return (
    <section className="wrap sec" id="guides">
      <div className="sec-head">
        <div>
          <div className="idx">
            KNOWLEDGE BASE &middot; <b>7 PILLARS</b>
          </div>
          <h2>Where To Build Your Readiness</h2>
        </div>
        <a className="link-more" href="#start">
          Start Here Path &rarr;
        </a>
      </div>
      <div className="pillars">
        {pillars.map((p) => (
          // No dedicated per-pillar hub page exists yet — link to the real
          // archive rather than a dead "#". Revisit once pillar hub pages
          // (one per topic, filtering the archive) get built.
          <Link className="pill" to="/articles" key={p.num} style={p.full ? { gridColumn: '1 / -1' } : undefined}>
            <span className="num">{p.num}</span>
            <span className="pc">
              <h3>{p.title}</h3>
              <p>{p.desc}</p>
            </span>
            <span className="arw" aria-hidden="true">
              &rarr;
            </span>
          </Link>
        ))}
      </div>
    </section>
  )
}
